<template>
  <div
    class="spinner animate-spin"
    :class="size"
    :style="{
      borderColor: getBorderColor,
    }"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  size: { type: String, default: "sm" }, //sm, md, lg
  color: { type: String, default: "white" },
});
const getBorderColor = computed(() => {
  return `var(--${props.color})`;
});
</script>

<style scoped>
.spinner {
  @apply border rounded-full inline-block box-border !border-b-transparent;
}
.spinner.sm {
  @apply w-6 h-6 border-[3px];
}
.spinner.md {
  @apply w-9 h-9 border-4;
}
.spinner.lg {
  @apply w-12 h-12 border-[5px];
}
</style>
